import { MotoristaTabs } from './MotoristaTabs'
export function Motorista() {

  return (
    <>
      <h1 className="text-3xl font-medium text-zinc-900 dark:text-zinc-100">
        Inscrições
      </h1>
      <MotoristaTabs />
    </>
  )
}
